

































import Content from '@/components/common/Content.vue'
import { Component, Watch } from 'vue-property-decorator'
import Configuration from "@/components/products/malennachzahlen/steps/ConfigurationImpl.vue"
import Design from "@/components/products/malennachzahlen/design/DesignImpl.vue"
import Warning from "@/components/products/malennachzahlen/PaintingByNumbersWarning.vue"
import PaintingByNumbersHeadline from "@/components/products/malennachzahlen/PaintingByNumbersHeadline.vue"
import ProductPreview from "@/components/products/malennachzahlen/design/ProductPreviewImpl.vue"
import { AppModule, Step } from "@/store/modules/app"
import { TextCanvasConfig } from '@/components/common/TextCanvas.vue'
import CartButton from "@/components/products/malennachzahlen/util/CartButton.vue"
import Gift from "@/components/products/malennachzahlen/GiftImpl.vue"
import GiftOptionsButton from "@/components/products/malennachzahlen/PaintingByNumbersGiftOptionsButton.vue"
import { PaintingByNumbersModule, PaintingFormat } from '../../../store/modules/paintingByNumbers';
import getCategories from '@/components/products/malennachzahlen/util/categoryUtil'
import getDesigns from '@/components/products/malennachzahlen/util/designUtil'
import getImageRatios from '@/components/products/malennachzahlen/util/imageRatioUtil'
import { getParts }from '@/components/products/malennachzahlen/util/partsUtil'
import TagCommander from "@/components/common/TagCommander.vue"
import ShippingOverlay from "@/components/common/ShippingOverlay.vue"
import Impressum from '@/components/Impressum.vue'

@Component({
  name: "painting-by-numbers-content",
  components: {
    PaintingByNumbersHeadline,
    Design,
    Configuration,
    Warning,
    ProductPreview,
    CartButton,
    GiftOptionsButton,
    Gift,
    TagCommander,
    ShippingOverlay,
    Impressum
  }
})
export default class PaintingByNumbersContent extends Content {
  private showCartButton: boolean = false
  private titleTextConfig: TextCanvasConfig = new TextCanvasConfig(27, 27, 1.4, 362, 32, '"Whiskers", sans-serif', 1, "400")
  private puzzlePlaceholderStyle: string = "position: absolute; top: -7px; width: 300px; opacity: .4; left: 50px; z-index: 100; pointer-events: none; touch-action: none;"
  private initIsRunning = false

  get imageEditorWidth() {
    return PaintingByNumbersModule.imageEditorWidth
  }

  get imageEditorHeight() {
    return PaintingByNumbersModule.imageEditorHeight
  }

  get showGiftOptions() {
    return AppModule.showGiftOptions
  }

  get availableCategories() {
    return PaintingByNumbersModule.availableCategories
  }

  get availableDesigns() {
    return PaintingByNumbersModule.availableDesigns
  }

  get parts() {
    return PaintingByNumbersModule.parts
  }

  get format() {
    return PaintingByNumbersModule.format
  }

  get designsNotEmpty() {
    return PaintingByNumbersModule.designsNotEmpty
  }

  get stepsReseted() {
    return PaintingByNumbersModule.stepsReseted
  }

  get showMenu() {
    return AppModule.showMenu
  }

  get resetBoxDesignToggled() {
    return PaintingByNumbersModule.resetBoxDesignToggled
  }

  get productId() {
    return AppModule.productID
  }

  @Watch('parts')
  partsChanged(newParts: string) {
    this.initCategories()
  }

  @Watch('resetBoxDesignToggled')
  resetBoxDesignToggledChanged(boxDesignToggled: boolean) {
    this.initCategories()
  }

  @Watch('stepsReseted')
  stepsResetedChanged(newStepsReseted: boolean) {
    this.initCategories()
    this.toggleFooterButton(false)
  }

  /*@Watch('productId')
  productIdChanged(newProductId: string) {
    (this.$refs.tagCommander as TagCommander).reload()
  }*/

  toggleFooterButton(state:boolean) {
    this.showCartButton = state
  }

  created() {
    this.initSteps()
    this.initProductName()
    this.initAvailableProducts()
    this.initCategories()
    this.initImageRatios()
    this.initAssets()
    this.$nextTick(() => {
      AppModule.SetActiveStep(0)
    })
    AppModule.SetHidePreviewButton(true)
  }

  initSteps(): void {
    AppModule.SET_STEPS([
      new Step(this.$t('stepOne').toString(), "painting-image-upload", false, 'paintingimage', [[this.imageEditorWidth, this.imageEditorHeight], [480, 420], [0,0]], this.$t('paintingStepOneInfo').toString(), undefined, this.puzzlePlaceholderStyle),
      new Step(this.$t('paintingStepTwo').toString(), "design-painting", false, 'paintingimage', [[this.imageEditorWidth, this.imageEditorHeight], [480, 420], [0,0]], this.$t('paintingStepTwoInfo').toString(), undefined, this.puzzlePlaceholderStyle),
      new Step(this.$t('paintingStepThree').toString(), "design-box-metal", false, 'paintingimage', [[this.imageEditorWidth, this.imageEditorHeight], [480, 420], [0,0]], this.$t('paintingStepThreeInfo').toString()),
      new Step(this.$t('paintingStepFour').toString(), "enter-title", true, 'paintingimage', [[this.imageEditorWidth, this.imageEditorHeight], [480, 420], [0,0]], this.$t('paintingStepFourInfo').toString(), this.titleTextConfig, undefined)
    ])
  }

  initProductName(): void {
    if (!AppModule.productID) {
      AppModule.SetProductID("81596")
    }
    let parts = getParts(AppModule.productID)
    if (parts) {
      PaintingByNumbersModule.SetParts(parts)
    }
  }

  public initCategories(): void {
    if (!this.initIsRunning) {
      this.initIsRunning = true
      PaintingByNumbersModule.ClearCategories(true)
      PaintingByNumbersModule.ClearDesigns(true)
      PaintingByNumbersModule.ClearNotEmptyDesigns(true)
      getCategories().then(() => {
        let promises = []
        for (let i = 0; i < this.availableCategories.length; i++){
          promises.push(getDesigns(this.availableCategories[i].id, this.parts, PaintingFormat[this.format], "PAPER_BOX").then(() => {
            for (let k = 0; k < this.availableDesigns.length; k++){
              if (this.availableDesigns[k].length !== 0){
                let categoryId = Number(this.availableDesigns[k][0].designCategories)
                if (categoryId !== undefined && !this.designsNotEmpty.includes(categoryId)) {
                  PaintingByNumbersModule.SetDesignNotEmpty(categoryId)
                }
              }
            }
          }))
          promises.push(getDesigns(this.availableCategories[i].id, this.parts, PaintingFormat[this.format], "METAL_BOX").then(() => {
            for (let k = 0; k < this.availableDesigns.length; k++){
              if (this.availableDesigns[k].length !== 0){
                let categoryId = Number(this.availableDesigns[k][0].designCategories)
                if (categoryId !== undefined && !this.designsNotEmpty.includes(categoryId)) {
                  PaintingByNumbersModule.SetDesignNotEmpty(categoryId)
                }
              }
            }
          }))
        }
        Promise.all(promises).then(() => {
          this.initDesignNr()
          PaintingByNumbersModule.setUpdatedCategories(!PaintingByNumbersModule.updatedCategories)
          this.initIsRunning = false
        })
      })
    }
  }

  sortList(list: any[]){
    return list.sort((a, b) => {
      return a.sort! - b.sort!;
    });
  }

  initDesignNr(): void {
    let minSort = -1
    let idWithMinSort = -1
    let designs = []
    for (let i = 0; i < this.availableCategories.length; i++){
      let currentId = this.availableCategories[i].id
      if (currentId !== undefined){
        if (this.designsNotEmpty.includes(currentId)){
          let currentSort = this.availableCategories[i].sort
          if (currentSort !== undefined){
            if(minSort === -1) {
              minSort = currentSort
              idWithMinSort = currentId
            }
            if (currentSort < minSort) {
              minSort = currentSort
              idWithMinSort = currentId
            }
          }
        }
      }
      for (let j = 0; j < this.availableDesigns.length; j++){
        if (this.availableDesigns[j].length !== 0){
          let categoryId = Number(this.availableDesigns[j][0].designCategories)
          if (categoryId === idWithMinSort) {
            for (let k = 0; k < this.availableDesigns[j].length; k++){
              let online = this.availableDesigns[j][k].online
              if (online) {
                designs.push(this.availableDesigns[j][k])
              }
            }
          }
        }
      }
    }
    designs = this.sortList(designs)
    if(designs[0].designNr !== undefined){
      PaintingByNumbersModule.SetBoxDesign(designs[0].designNr)
    }
  }

  initAvailableProducts(){
    let products: string[] = []
    if (AppModule.session.products !== undefined){
      for (let i = 0; i < AppModule.session.products.length; i++){
        let newParts = AppModule.session.products[i].parts
        if (newParts !== undefined) {
          if (!products.includes(newParts)) {
            products.push(newParts)
          }
        }
      }
    }
    PaintingByNumbersModule.SetAvailableParts(products)
  }

  initImageRatios() {
    getImageRatios()
  }

}
